module.exports = __webpack_public_path__ + "img/Logo_iNoe_384px.49693966.png";